import { Icon } from '../../../atoms/Icon';
import { Typography } from '../../../molecules/Typography';
import { useScheduleSlotContext } from '../useScheduleSlotContext';

interface IScheduleSlotContentSummaryProps {
  exercisesSolved?: number;
  lessonsWatched?: number;
  materialsSeen?: number;
}

export function ScheduleSlotContentSummary({
  exercisesSolved,
  lessonsWatched,
  materialsSeen,
}: IScheduleSlotContentSummaryProps) {
  const { disciplineSlug } = useScheduleSlotContext();
  const items = [
    {
      icon: 'edit',
      value: exercisesSolved,
      label: 'Exercícios resolvidos',
    },
    {
      icon: 'play_circle',
      value: lessonsWatched,
      label: 'Aulas assistidas',
    },
    {
      icon: 'library_books',
      value: materialsSeen,
      label: 'Materiais vistos',
    },
  ];

  return (
    <div className='flex items-center justify-between mt-5'>
      {items.map(({ icon, value, label }) => (
        <div
          key={label}
          className='flex max-w-[50px] flex-col items-center gap-sm'
        >
          <div className='flex items-center gap-sm'>
            <Icon
              Icon={icon}
              type='material'
              className={`text-[22px] text-disciplina-${disciplineSlug}`}
            />
            <Typography weight='bold'>{value}</Typography>
          </div>
          <Typography size={'mini'}>{label}</Typography>
        </div>
      ))}
    </div>
  );
}
